// entornoDespliegue.js
//
// Qué pinta el pie de la aplicación principal debajo de la fecha de build. El valor lo firma
// el build en `process.env.ENTORNO_ETIQUETA` (fuente única: `build/build-info.js`, inyectado
// por el DefinePlugin de `build/webpack.config.js`), y aquí solo se decide cómo se presenta.
//
// Dos reglas duras, las mismas que aplica el sello del CRM NEW (`crm-new/src/layout/sello.ts`;
// son dos builds distintos y no pueden compartir módulo, así que comparten la regla):
//
//   1. Si la etiqueta no llega —bundle viejo, variable vacía, solo espacios— se dice
//      «entorno no identificado». NUNCA se asume producción: un pie que dice PRO apuntando a
//      pruebas es lo que levantó un P0 en la #229.
//   2. En el pie no se publica ninguna dirección interna. Si lo que llega parece una URI, un
//      host con esquema o una IP, se descarta entero y se dice «no identificado». No se recorta
//      ni se tapa la parte sospechosa: si ahí hay una dirección, lo que falla es la
//      configuración del build, no el texto.

export const ENTORNO_NO_IDENTIFICADO = 'entorno no identificado';
const NO_IDENTIFICADO = ENTORNO_NO_IDENTIFICADO;

// `://` (cualquier URI), `@` (credencial o host de correo), `http`/`https` sueltos y una IPv4.
const PARECE_DIRECCION = /:\/\/|@|\bhttps?\b|\b\d{1,3}(\.\d{1,3}){3}\b/i;

/**
 * Normaliza la etiqueta de entorno firmada por el build.
 * Devuelve siempre un texto presentable, nunca vacío.
 */
export function etiquetaEntorno(valor) {
  if (valor === undefined || valor === null) return NO_IDENTIFICADO;
  const limpio = String(valor).trim();
  if (limpio.length === 0) return NO_IDENTIFICADO;
  if (PARECE_DIRECCION.test(limpio)) return NO_IDENTIFICADO;
  return limpio;
}

/**
 * Compone el texto del pie: `<BUILDDATE> · <entorno>`.
 *
 * `BUILDDATE` se pinta TAL CUAL —sufijo PRO/DEV incluido—: es el identificador que se sella en
 * las inspecciones y no cambia de formato. El entorno se añade detrás, no lo sustituye.
 */
export function pieConEntorno(buildDate, entorno) {
  const fecha = buildDate === undefined || buildDate === null ? '' : String(buildDate).trim();
  const etiqueta = etiquetaEntorno(entorno);
  return fecha.length === 0 ? etiqueta : `${fecha} · ${etiqueta}`;
}
